<template>
    <base_location_modal :tabs_advanced="tabs_add">
        <template v-slot:location_general_info="{ location, name }">
            <wolt_general_tab :location="location"></wolt_general_tab>
        </template>


        <template v-slot:wolt_work_hour="{ location, name }">
            <wolt_work_hour :location="location"></wolt_work_hour>
        </template>

    </base_location_modal>
</template>

<script>

import base_location_modal from "../../base/location_modal/base_location_modal";
import wolt_general_tab from "./tabs/wolt_general_tab";
import wolt_work_hour from "./tabs/wolt_work_hour.vue";


export default {
    name: "wolt_location_modal",
    components : {
        base_location_modal,
        wolt_general_tab,
        wolt_work_hour
    },
    data () {
        return {
            tabs_add: [
                {
                    index : "wolt_work_hour",
                    title : this.__t('WOLT_WORK_HOUR'),
                },
            ]
        }
    },
}
</script>

<style scoped>

</style>
